import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';
import Litepicker from 'litepicker';
import {detectBreakpoint} from "../../../../../paws/assets/frontend/js/helper/breakpoint";

whenDocumentReady(initModule);
function initModule() {
    let targetElement = document.getElementById('pindatarange');

    let currentBreakpoint = detectBreakpoint()
    let numberMonths = 1;
    if (currentBreakpoint == 'xxl' || currentBreakpoint == 'xl') {
        numberMonths = 3;
    }

    const picker = new Litepicker({
        element: targetElement,
        format: 'DD.MM.YYYY',
        lang: 'de-DE',
        singleMode: false,
        numberOfMonths: numberMonths,
        numberOfColumns: numberMonths,
        switchingMonths: 1,
        maxDate: new Date(targetElement.dataset.maxdate * 1000),
        minDate: new Date(targetElement.dataset.mindate * 1000),
        autoRefresh: true,
    });
    picker.on('selected', (date1, date2) => {
        htmx.trigger(targetElement, 'change');
    });

    const element = document.querySelector('.noss_sendeprotokoll.pindaten .fixedtable')
    const scrollbar = document.createElement("div");
    scrollbar.appendChild(document.createElement("div"));
    scrollbar.style.overflow = "auto";
    scrollbar.style.overflowY = "hidden";
    scrollbar.firstChild.style.width = element.scrollWidth + "px";
    scrollbar.firstChild.style.paddingTop = "1px";
    scrollbar.firstChild.appendChild(document.createTextNode("\xA0"));
    let running = false;
    // Keep scrollbar in sync when element size changes
    new ResizeObserver(() => {
        scrollbar.firstChild.style.width = element.scrollWidth + "px";
    }).observe(element.querySelector('table'));
    scrollbar.onscroll = function () {
        if (running) {
            running = false;
            return;
        }
        running = true;
        element.scrollLeft = scrollbar.scrollLeft;
    };
    element.onscroll = function () {
        if (running) {
            running = false;
            return;
        }
        running = true;
        scrollbar.scrollLeft = element.scrollLeft;
    };
    element.parentNode.insertBefore(scrollbar, element);
}
